module.exports = __webpack_public_path__ + "img/review-boxer.c34cb266.webp";